import React from 'react';
import visionImage from '../images/VisionImage.jpeg';
import './Introduction.css';

const Introduction = () => {
  return (
    <section className="introduction" id="about">
      <div className="container">
        <div className="intro-content">
          <div className="intro-text">
            <h2>Our Vision: Education for All</h2>
            <blockquote className="thirukkural">
              "கற்க கசடறக் கற்பவை கற்றபின் நிற்க அதற்குத் தக."
              <cite>Learn perfectly what is to be learned, and then live up to what you have learned.</cite>
            </blockquote>
            <p>At Ezhuthaani.org, we embody the timeless wisdom of Thiruvalluvar, believing that education is the foundation of human progress. Our mission is to break down financial barriers that prevent deserving students from accessing quality education, from elementary school through college.</p>
          </div>
          <div className="intro-image">
            <img src={visionImage} alt="Education empowerment" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Introduction;